<ng-container *ngIf="environmentName">
  <div class="vertical-menu-item" id="environmenMarker" [ngStyle]="backgroundStyle">
    <span>{{environmentName | translate}}</span>
  </div>
</ng-container>
